import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { I18N_NAMESPACES } from "../../../helpers/constants";
import { GetWine_wine as WineType } from "../../../types/__generated__/GetWine";

import {
  SectionTitle,
  SeeMore,
  CountryMap,
  CountryName,
  CountryFlag,
  CountryRegionInfo,
  Description,
  TextWrapper,
  WineRegionWrapper,
  CountryFlagWrapper,
} from "./style";

interface WineRegionProps {
  wine: WineType | null | undefined;
  isWineDetailsPage: boolean;
}

const WineRegion = ({ wine, isWineDetailsPage }: WineRegionProps) => {
  const { t } = useTranslation([I18N_NAMESPACES.WINE_PAGES]);
  const [isReadMoreShown, setIsReadMoreShown] = useState<boolean>(true);
  const { wineRegion, country } = wine || {};

  const shouldShowSection: boolean = !!wineRegion?.mapUrl || !!wineRegion?.fullDescription;
  if (!shouldShowSection) {
    return <></>;
  }

  const buttonLocaleKey = isReadMoreShown ? "readMore" : "readLess";

  return (
    <WineRegionWrapper isWineDetailsPage={isWineDetailsPage}>
      <SectionTitle>{t("winePages:region")}</SectionTitle>
      <CountryRegionInfo>
        {wineRegion?.mapUrl && <CountryMap src={wineRegion?.mapUrl} />}
        <CountryFlagWrapper isContentAlignCenter={!!wineRegion?.mapUrl}>
          {country?.code && <CountryFlag countryCode={country?.code.toLowerCase()} />}
          <CountryName>{[wineRegion?.name, country?.name].join(", ")}</CountryName>
        </CountryFlagWrapper>
      </CountryRegionInfo>
      {wineRegion?.fullDescription && (
        <>
          <TextWrapper isOpen={!isReadMoreShown}>
            <Description>{wineRegion?.fullDescription}</Description>
          </TextWrapper>
          <SeeMore onClick={() => setIsReadMoreShown(!isReadMoreShown)}>
            {t(`common:${buttonLocaleKey}`)}
          </SeeMore>
        </>
      )}
    </WineRegionWrapper>
  );
};

export default WineRegion;
